import { validateBoleto } from '~/helpers/validation/boleto';
import { ValidateRequest } from '~/api';

export type BoletoAction =
  | { type: 'query'; request: ValidateRequest }
  | { type: 'reject' }
  | { type: 'invalid' };

export function resolveBoletoAction(rawInput: string): BoletoAction {
  const result = validateBoleto(rawInput);

  if (result.kind === 'thirdParty') {
    return { type: 'reject' };
  }

  if (result.kind === 'invalid') {
    return { type: 'invalid' };
  }

  if (result.normalized.length === 47) {
    return { type: 'query', request: { digitableLine: result.normalized } };
  }

  return { type: 'query', request: { barcode: result.normalized } };
}
